<table mat-table [dataSource]="data" style="width: 100%;" aria-describedby="Direct Offer Quote">
    <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
            <div class="stipend-excess-container" *ngIf="row.hasGsaRates">
                <mat-icon *ngIf="row.hasStipendExcess" class="stipend-excess-error-icon"
                    matTooltip="Stipend maximum exceeded" inline="true">information
                </mat-icon>
            </div>
            <mat-icon *ngIf="!row.hasGsaRates" matTooltip="Sorry no Per Diem limits available for this job"
                inline="true">warning</mat-icon>
        </td>
    </ng-container>

    <ng-container matColumnDef="targetMargin">
        <th mat-header-cell *matHeaderCellDef>Target Margin</th>
        <td mat-cell *matCellDef="let row">{{ (row.targetMargin / 100) | percent }}</td>
    </ng-container>

    <ng-container matColumnDef="marginPct">
        <th mat-header-cell *matHeaderCellDef>Margin</th>
        <td mat-cell *matCellDef="let row">
            <mat-form-field style="width: 60px;">
                <input matInput type="number" min="0" name="marginPct" [ngModel]="row.marginPct"
                    (ngModelChange)="marginPctChanged(row, $event)">
                <span matSuffix>%</span>
            </mat-form-field>
        </td>
    </ng-container>

    <ng-container matColumnDef="relocation">
        <th mat-header-cell *matHeaderCellDef>Relocation</th>
        <td mat-cell *matCellDef="let row">
            <mat-form-field style="width: 50px;">
                <span matPrefix>$</span>
                <input matInput type="number" min="0" [ngModel]="row.relocation"
                    (ngModelChange)="relocationChanged(row, $event)">
            </mat-form-field>
        </td>
    </ng-container>

    <ng-container matColumnDef="ayaHousing">
        <th mat-header-cell *matHeaderCellDef>Aya Housing</th>
        <td mat-cell *matCellDef="let row">
            <mat-checkbox [checked]="row.ayaHousing" (change)="selectAyaHousing(row, $event)">
                <div>Aya Housing</div>
            </mat-checkbox>
        </td>
    </ng-container>

    <ng-container matColumnDef="weeklyPay">
        <th mat-header-cell *matHeaderCellDef>Weekly Pay*</th>
        <td mat-cell *matCellDef="let row">
            <div>{{ row.weeklyPay | currency }}</div>
            <div *ngIf="row.altWeeklyPay > 0">{{ row.altWeeklyPay | currency }} </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="equal">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">=</td>
    </ng-container>

    <ng-container matColumnDef="taxable">
        <th mat-header-cell *matHeaderCellDef>Taxable/Non-Taxable</th>
        <td mat-cell *matCellDef="let row">
            <div>
                {{ row.taxable | currency }} + {{ row.nonTaxable | currency }}
            </div>
            <div *ngIf="row.taxableAltPay > 0 && row.nonTaxableAltPay > 0">
                {{ row.taxableAltPay | currency }} + {{ row.nonTaxableAltPay | currency }}
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="facility">
        <th mat-header-cell *matHeaderCellDef>Facility</th>
        <td mat-cell *matCellDef="let row">{{ row.facilityName }}</td>
    </ng-container>

    <ng-container matColumnDef="housingCost">
        <th mat-header-cell *matHeaderCellDef>Housing Cost</th>
        <td mat-cell *matCellDef="let row">{{ row.housingCost | currency}}</td>
    </ng-container>

    <ng-container matColumnDef="jobTitle">
        <th mat-header-cell *matHeaderCellDef>Job Title</th>
        <td mat-cell *matCellDef="let row">{{ row.jobTitle }}</td>
    </ng-container>

    <ng-container matColumnDef="shift">
        <th mat-header-cell *matHeaderCellDef>Shift</th>
        <td mat-cell *matCellDef="let row">
            <div>{{row.shiftsText}}</div>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
